import { NgModule } from '@angular/core';
import { TileContainerDirective } from './tile-container.directive';
import { TileParametersDefDirective } from './tile-parameters-def.directive';

@NgModule({
   declarations: [TileContainerDirective, TileParametersDefDirective],
   imports: [],
   exports: [TileContainerDirective, TileParametersDefDirective],
})
export class TileDirectivesModule {}
